import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVisualstudiocodeComponent } from './simple-icons-visualstudiocode.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVisualstudiocodeComponent ],
    exports:      [ SimpleIconsVisualstudiocodeComponent ],
    bootstrap:    []
})
export class SimpleIconsVisualstudiocodeModule {}
